/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PopupInfo = {
    ID: string;
    TITLE: string;
    EXPST: string;
    EXPEND: string;
    EXPPG: PopupInfo.EXPPG;
    EXPURL: string;
    TYPE: PopupInfo.TYPE;
    PCIMG: string;
    MOIMG: string;
    LURL?: string;
    LTG?: PopupInfo.LTG;
    EXPSTA?: PopupInfo.EXPSTA;
    PGSTA?: PopupInfo.PGSTA;
};

export namespace PopupInfo {

    export enum EXPPG {
        LANDING = 'LANDING',
        SPECIFIED = 'SPECIFIED',
    }

    export enum TYPE {
        GENERAL_IMAGE = 'GENERAL_IMAGE',
        MAINTENANCE = 'MAINTENANCE',
    }

    export enum LTG {
        CURRENT_TAB = 'CURRENT_TAB',
        NEW_TAB = 'NEW_TAB',
        NEW_WINDOW = 'NEW_WINDOW',
    }

    export enum EXPSTA {
        Y = 'Y',
        N = 'N',
    }

    export enum PGSTA {
        WAITING = 'WAITING',
        PROGRESS = 'PROGRESS',
        END = 'END',
    }


}

